import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDidMount, useStateWithCallback } from "../../utils/hooks";
import { getDirection, pexios } from '../../utils/functions';
import { history } from '../../utils/variables';
import { setRouterData } from '../../redux/actions';
import Moment from 'moment-jalaali';
import Pagination from "../../components/master/Pagination";
import { useTranslation } from 'react-i18next';



export default function RegisterList() {
    const { t, i18n } = useTranslation();
    const user = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const [registers, setRegisters] = useState([]);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useStateWithCallback(1);
    const [lastPage, setLastPage] = useState(1);

    const status = [
        t('Requested'),
        t('Wait to confirm'),
        t('Review and audit'),
        t('Confirmed'),
        t('Issued'),
    ];

    const loadRegisters = useCallback((page = 1) => {
        setLoader(true);
        const api = user.type ==='user' ? 'creator_register_list' : 'expert_register_list';
        pexios(`api/v2/${api}?page=${page}`).then(res=>{
            const result = res.data;
            setLoader(false);
            setRegisters(result.data);
            setLastPage(result.meta.last_page);
        });
    }, [user.type]);

    useDidMount(() => loadRegisters());

    function changePage(page) {
        setCurrentPage(page, (currentPage) => loadRegisters(currentPage));
    }
    function goToDetails(id) {
        dispatch(setRouterData({ id, type: 'register' }));
        history.push('/register-single');
    }

    return (
        <div className='content report'>
            <div
                className='text-center'
            >
                {
                    loader ?
                        <i className='fa fa-spinner fa-spin' /> :
                        <table className={`${getDirection(i18n.language) === 'leftToRight' ? 'ltr':'rtl'}`}>
                            <thead>
                            <tr>
                                <td className='text-center'>{t('Identification')}</td>
                                <td className='text-center'>{t('State')}</td>
                                <td className='text-center'>{t('Date')}</td>
                                <td className='text-center'>{t('Operation')}</td>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                registers.map((register, index) => (
                                    <tr key={index}>
                                        <td className='text-center'>{register.id}</td>
                                        <td className='text-center'>
                                            { status[register.status] }
                                        </td>
                                        <td className='text-center'>
                                            { Moment(register.created_at).format('jYYYY/jM/jD') }
                                        </td>
                                        <td className='text-center'>
                                            <button onClick={() => goToDetails(register.id)} className='btn btn-sm btn-green btn-circle'>
                                                {t('Watch')}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                }
                <div className='mt20'>
                    <Pagination
                        currentPage={currentPage}
                        total={lastPage}
                        changePage={changePage}
                    />
                </div>
            </div>
        </div>
    );

}
